export default __webpack_public_path__ + "static/media/Darksun.6e979e09.jpg";